import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getElectricMeterTrend } from '@/service/operate/energyManagement';
export default function useTrend(params) {
  var trendData = ref([]);
  var trendYearData = ref([]);
  // 获取主机汇总数据
  var getElectricMeterTrendAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var num, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            num = 30;
            _context.t0 = params.value.type;
            _context.next = _context.t0 === 0 ? 4 : _context.t0 === 1 ? 6 : _context.t0 === 2 ? 8 : _context.t0 === 3 ? 10 : _context.t0 === 4 ? 12 : 14;
            break;
          case 4:
            num = 30;
            return _context.abrupt("break", 15);
          case 6:
            num = 30;
            return _context.abrupt("break", 15);
          case 8:
            num = 12;
            return _context.abrupt("break", 15);
          case 10:
            num = 3;
            return _context.abrupt("break", 15);
          case 12:
            num = 10;
            return _context.abrupt("break", 15);
          case 14:
            num = 30;
          case 15:
            _context.next = 17;
            return getElectricMeterTrend(_objectSpread(_objectSpread({}, params.value), {}, {
              rangeType: params.value.type === 0 ? 5 : params.value.type,
              rangeNum: num
            }));
          case 17:
            data = _context.sent;
            trendData.value = data.list;
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getElectricMeterTrendAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getElectricMeterTrendYearAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getElectricMeterTrend({
              type: 3,
              date: params.value.date,
              rangeType: -1,
              rangeNum: 3
            });
          case 2:
            data = _context2.sent;
            trendYearData.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getElectricMeterTrendYearAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  var trendCountData = computed(function () {
    var lineData1 = trendData.value.map(function (item) {
      return item.electric_value;
    });
    var lineData2 = trendData.value.map(function (item) {
      return item.electric_fee;
    });
    var xLabels = trendData.value.map(function (item) {
      return item.time;
    });
    // const legendData = ['电量', '电费'];
    var legendData = ['电量'];
    return {
      xLabels: xLabels,
      lineData: [lineData1, lineData2],
      legendData: legendData,
      colors: ['#82A3FF', '#5AC57F', '#EEC324'],
      grid: {
        left: 55,
        top: 10,
        bottom: 55,
        right: 20
      },
      legendBottom: 2,
      customTooltip: true,
      tooptipFormatter: function tooptipFormatter(params1) {
        var res = "\n                <div >\n                  <div class=\"flex align-center\">\n                    <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                  </div>\n                ");
        params1.forEach(function (item) {
          res += "\n                  <div >\n                    ".concat(item.marker, "\n                    <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                    <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '电量' ? '度' : '元', "</span>\n                  </div>\n                ");
        });
        res += '</div>';
        return res;
      }
    };
  });
  var trendCountYearData = computed(function () {
    var lineData1 = trendYearData.value.map(function (item) {
      return item.electric_value;
    });
    var lineData2 = trendYearData.value.map(function (item) {
      return item.electric_fee;
    });
    var xLabels = trendYearData.value.map(function (item) {
      return item.time;
    });
    var legendData = ['电量', '电费'];
    return {
      xLabels: xLabels,
      lineData: [lineData1, lineData2],
      legendData: legendData,
      colors: ['#82A3FF', '#5AC57F', '#EEC324'],
      grid: {
        left: 55,
        top: 10,
        bottom: 55,
        right: 20
      },
      legendBottom: 2,
      customTooltip: true,
      tooptipFormatter: function tooptipFormatter(params1) {
        var res = "\n                <div >\n                  <div class=\"flex align-center\">\n                    <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                  </div>\n                ");
        params1.forEach(function (item) {
          res += "\n                  <div >\n                    ".concat(item.marker, "\n                    <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                    <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '电量' ? '度' : '元', "</span>\n                  </div>\n                ");
        });
        res += '</div>';
        return res;
      }
    };
  });
  return [trendCountData, trendCountYearData, getElectricMeterTrendAsync, getElectricMeterTrendYearAsync];
}